import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from '../Divider';
export const NavItemSeparator = (_a) => {
    var { component = 'li', role = 'presentation' } = _a, props = __rest(_a, ["component", "role"]);
    return _jsx(Divider, Object.assign({ component: component, role: role }, props));
};
NavItemSeparator.displayName = 'NavItemSeparator';
//# sourceMappingURL=NavItemSeparator.js.map